/* eslint-disable no-undef */
const React = require("react");
require("bootstrap/js/dist/collapse");
require("bootstrap/js/dist/modal");
require("bootstrap/js/dist/dropdown");
const { CartProvider } = require("react-use-cart");

/* eslint-disable no-undef */
exports.wrapRootElement = ({ element }) => {
  return (
    <CartProvider>
      {element}
    </CartProvider>
  );
};